import pageData from '../../../common/tour/data.json';
import styles from './index.module.less';

function TalentPC() {
  const renderStudy = () => (
    <div className={styles.station}>
      <div className={styles.subtitle}>{pageData.study.title}</div>
      <div className={styles.content}>{pageData.study.content1}</div>
      <img src={pageData.study.imgList[0]} alt="" className={styles.station__img} />
    </div>
  );

  const renderIndustrial = () => (
    <div className={styles.station}>
      <div className={styles.subtitle}>{pageData.industrial.title}</div>
      <div className={styles.content}>{pageData.industrial.content1}</div>
      <img src={pageData.industrial.imgList[0]} alt="" className={styles.station__img} />
    </div>
  );
  const renderConsultation = () => (
    <div className={styles.station}>
      <div className={styles.subtitle}>{pageData.consultation.title}</div>
      <div className={styles.content}>{pageData.consultation.content1}</div>
      <img src={pageData.consultation.imgList[0]} alt="" className={styles.station__img} />
    </div>
  );
  const renderObservation = () => (
    <div className={styles.station}>
      <div className={styles.subtitle}>{pageData.observation.title}</div>
      <div className={styles.content}>{pageData.observation.content1}</div>
      <img src={pageData.observation.imgList[0]} alt="" className={styles.station__img} />
    </div>
  );

  return (
    <section className={styles.local}>
      <div className={styles.local__container}>
        {renderStudy()}
        {renderIndustrial()}
        {renderConsultation()}
        {renderObservation()}
      </div>
    </section>
  );
}

export default TalentPC;
